import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star",
  "use": "star-usage",
  "viewBox": "0 0 23.715 21.756",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23.715 21.756\" id=\"star\"><path data-name=\"Path 4039\" d=\"M11.747.505a.472.472 0 0 0-.31.221l-3.67 5.969L.899 8.066a.472.472 0 0 0-.251.8l5.026 5.026-.914 6.839a.472.472 0 0 0 .663.486l6.411-2.741 6.411 2.741a.471.471 0 0 0 .663-.486l-.914-6.839L23.02 8.86a.472.472 0 0 0-.25-.8l-6.868-1.371L12.232.72a.472.472 0 0 0-.442-.215Z\" fill=\"none\" stroke=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol